import cookies from './util.cookies'
import db from './util.db'
import log from './util.log'
import token from './util.token'

const util = {
  cookies,
  db,
  log,
  token
}

/**
 * @description 更新标题
 * @param {String} title 标题
 */
util.title = function(titleText) {
  const processTitle = process.env.VUE_APP_TITLE || 'ABS'
  window.document.title = `${processTitle}${titleText ? ` | ${titleText}` : ''}`
}

/**
 * @description 打开新页面
 * @param {String} url 地址
 */
util.open = function(url) {
  var a = document.createElement('a')
  a.setAttribute('href', url)
  a.setAttribute('target', '_blank')
  a.setAttribute('id', 'd2admin-link-temp')
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(document.getElementById('d2admin-link-temp'))
}

/**
 * 嵌套数组扁平化
 * @param {*} arr 需要扁平化的数组
 * @param {*} key 嵌套key
 * @returns 扁平化后的结果
 */
export const flat = (arr, key) => {
  let res = []

  const exec = (arr, key) => {
    arr.forEach((t) => {
      res.push(t)
      if (key && t[key] && t[key].length) {
        exec(t[key], key)
      }
    })
  }

  exec(arr, key)

  return res
}

util.flat = flat

export default util
